import { Color } from '@/constants/color';

const statusColor: { [key: string]: Color } = {
  open: Color.RED,
  done: Color.GREEN, // alias for closed
  in_progress: Color.BLUE,
  snoozed: Color.YELLOW,
  closed: Color.GREEN
};

export default statusColor;
